import $ from 'jquery';

$('.newsletter-bar__submit').on('click', function(e) {
    var inputContent = $(this).parents('.newsletter-bar').find('.newsletter-bar__input').val();
    var targetPage = $(this).attr('href');
    if(inputContent) {
        e.preventDefault();
        window.location.href = targetPage + "?email=" + inputContent;
    }

    console.log(targetPage + "?email=" + inputContent);
});
